module.exports = __webpack_public_path__ + "static/media/S-S.917608c0.webp";